import { createContext } from 'react';

import type { NExtraPageTitleProvider } from '@app/providers/ExtraPageTitleProvider/ExtraPageTitleProvider.types';

export const ExtraPageTitleContext =
  createContext<NExtraPageTitleProvider.Context>({
    titleData: '',
    setTitleData: () => {},
  });
